import PropTypes from 'prop-types';

export const nullStatePropTypes = {
  cardBody: PropTypes.node.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  cardTitle: PropTypes.string.isRequired
};
